import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import ReactGA from 'react-ga';

import { tabAIState } from '../../../modules/tabAI';
import { media } from '../../common/Layout';

const RecommendedWordComponent = styled.div`
  width: 100%;
  border-radius: 8px;
  border: solid 1px #e1e6f0;

  /* Mobile Device */
  padding: 12px 10px 12px 10px;
  max-height: 93px;
  margin-top: 10px;

  ${media.desktop`
    padding: 12px 25px 12px 25px;
    max-height: 105px;
    margin-top: 24px;
  `};
`;

const RecommendedWordTitle = styled.div`
  font-family: 'NotoKrM';
  color: #000000;
  font-weight: 500;

  /* Mobile Device */
  font-size: 14px;

  ${media.desktop`
    font-size: 16px;
  `};
`;

const RecommendedWordLinkBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  overflow: hidden;

  /* Mobile Device */
  margin-top: 8px;
  max-height: 41px;

  ${media.desktop`
    margin-top: 6px;
    max-height: 44px;
  `};
`;

const LinkItem = styled.div`
  font-family: 'NotoKrR';
  display: flex;
  color: #333333;
  margin-right: 10px;
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }

  /* Mobile Device */
  font-size: 13px;

  ${media.desktop`
    font-size: 14px;
  `};
`;

interface RecommendedWordProps extends RouteComponentProps {
  recommendedWord: tabAIState['recommendedWord'];
}

class RecommendedWord extends React.PureComponent<RecommendedWordProps, any> {
  makeLink = (): ReactNode[] | null => {
    const { recommendedWord, history } = this.props;
    const result: ReactNode[] | null = [];
    if (recommendedWord.length > 0) {
      recommendedWord.some((element, index) => {
        if (index > 10) {
          return true;
        }
        result.push(
          <LinkItem
            onClick={() => {
              ReactGA.ga('send', 'event', `click_search_ai_추천검색어`);
              history.push(`/search/ai?q=${element}`);
              window.location.reload(true);
            }}
          >
            {element}
          </LinkItem>
        );
        return false;
      });
    }

    return result;
  };

  render() {
    return (
      <RecommendedWordComponent>
        <RecommendedWordTitle>추천 검색어</RecommendedWordTitle>
        <RecommendedWordLinkBox>{this.makeLink()}</RecommendedWordLinkBox>
      </RecommendedWordComponent>
    );
  }
}

export default withRouter(RecommendedWord);
